const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const BrokerCashChargeStep1 = require('./brokerCashChargeStep1/brokerCashChargeStep1');
const BrokerCashChargeStep2 = require('./brokerCashChargeStep2/brokerCashChargeStep2');

// @ constants
const {
    BROKER_CORPORATE_OPERATIONS_URL
} = require('constants/index');

class BrokerCashChargeWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handleValidation = this.handleValidation.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { immBrokerCashCharge, onSetVisibleStep, onFinish, history } = newProps;
        const finished = immBrokerCashCharge.get('finished');
        const visibleStep = immBrokerCashCharge.get('visibleStep');
        const visibleStepValid = immBrokerCashCharge.getIn(['steps', visibleStep - 1, 'valid']);
        const visibleStepLast = visibleStep === immBrokerCashCharge.get('steps').size;

        if (visibleStepValid && !finished) {
            if (visibleStepLast) {
                onFinish(history);
            } else {
                onSetVisibleStep(visibleStep + 1);
            }
        }
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    handleValidation(step) {
        this.props.onValidateStep(step - 1);
    }

    render() {
        const {
            immBrokerCashCharge,
            onChangeTitlesAmount,
            onChangeAcceptedInstructions,
            onSetVisibleStep,
            onWillCancel,
            onFinish
        } = this.props;
        const visibleStep = immBrokerCashCharge.get('visibleStep');
        const immSteps = immBrokerCashCharge.get('steps');
        const actions = {
            validateStep: this.handleValidation,
            setVisibleStep: onSetVisibleStep,
            finish: onFinish,
            setWillCancel: onWillCancel,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                wizardClass="broker-cash-charge-wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
            >
                <BrokerCashChargeStep1
                    immBrokerCashCharge={immBrokerCashCharge}
                    actions={actions}
                    onChangeTitlesAmount={onChangeTitlesAmount}
                    onChangeAcceptedInstructions={onChangeAcceptedInstructions}
                />
                <BrokerCashChargeStep2
                    immBrokerCashCharge={immBrokerCashCharge}
                    actions={actions}
                />
            </Wizard>
        );
    }
}

BrokerCashChargeWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerCashCharge: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onChangeAcceptedInstructions: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerCashChargeWizard);
